import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { getVariables } from "./schema/get-variables";
import { searchDynamicVariable } from "./schema/search-dynamic-variable";

export const rpcDefinition = {
  getVariables,
  searchDynamicVariable,
};

export type RedoProceduresRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
